import Skeleton from '~/components/Skeleton';

import styles from './index.module.css';

const SwipeA = () => {
  return (
    <div className={styles.container}>
      <div className={styles.item}>
        <div className={styles.imageWrap}>
          <Skeleton width="" height="" className={styles.image} />
        </div>
        <Skeleton width={60} height={16} className="mt-6" />
        <Skeleton width={128} height={36} className="mt-6" />
        <Skeleton width={100} height={34} className="mt-6" />
        <Skeleton width={120} height={40} className="mt-6" />
      </div>
      <div className={styles.item}>
        <div className={styles.imageWrap}>
          <Skeleton width="" height="" className={styles.image} />
        </div>
        <Skeleton width={60} height={16} className="mt-6" />
        <Skeleton width={128} height={36} className="mt-6" />
        <Skeleton width={100} height={34} className="mt-6" />
        <Skeleton width={120} height={40} className="mt-6" />
      </div>
      <div className={styles.item}>
        <div className={styles.imageWrap}>
          <Skeleton width="" height="" className={styles.image} />
        </div>
        <Skeleton width={60} height={16} className="mt-6" />
        <Skeleton width={128} height={36} className="mt-6" />
        <Skeleton width={100} height={34} className="mt-6" />
        <Skeleton width={120} height={40} className="mt-6" />
      </div>
    </div>
  );
};

export default SwipeA;
